import React, { useEffect, useRef, useState, useContext } from "react";

import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { TabPanel, TabView } from "primereact/tabview";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";

import Card from "../../../../Base/Components/Card/Card";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import CalendarWeek, { getLastDayOfMonth } from "../../../../Base/Components/Form/CalendarWeek";
import { toastShow } from "../../../../Base/Services/ToastService";

import { changeEstadoActivos, changeEstadoSubActivos, getActivosFijos, getActivosFijosTotales, getActivosTotales, getSubActivosFijos } from "../../../../API/Global/ActivosFijos/ActivosFijosRequest";
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";

import ActivosFijosCRUD from "./ActivosFijosCRUD";
import SubActivosCRUD from "./SubActivos/SubActivosCRUD";
import ActivosConSubAct from "./ActivosConSubAct";
import DistribucionesDepreciacionActivosDialog from "./DistribucionesDepreciacionActivos/DistribucionesDepreciacionActivosDialog";
import ImagenActivos from "./ImagenActivos";
import ImagenSubActivos from "./ImagenSubActivos";
import QRCodeModal from "./QRCodeModal";
import { filtrarActivos } from "../../../../utils/Funciones/FuncionesGenerales";


const ActivosFijosScreen = ({ Finanzas = false }) => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [activosFijos, setActivosFijos] = useState([]);
  const [activosFijosPadre, setActivosFijosPadre] = useState([]);
  const [activosFijosTot, setActivosFijosTot] = useState([]);
  const [activosTotales, setActivosTotales] = useState([]);
  const [selected, setSelected] = useState([]);
  const [selected1, setSelected1] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogTotales, setShowDialogTotales] = useState(false);
  const [showDialog1, setShowDialog1] = useState(false);
  const [subActivosList, setSubActivosList] = useState([]);
  //const [activeIndex, setActiveIndex] = useState(Finanzas ? 0 : 1);
  const [activeIndex, setActiveIndex] = useState(0);
  const [fecha, setFecha] = useState(getLastDayOfMonth(new Date()));
  const [activoPadre, setActivoPadre] = useState(false);
  const [showDialogDistri, setShowDialogDistri] = useState(false)
  const [estados, setEstados] = useState([]);
  const [selectedSub, setSelectedSub] = useState([]);
  const [showDialogImagenes, setShowDialogImagenes] = useState(false);
  const [showDialogImagenesSUB, setShowDialogImagenesSUB] = useState(false);
  const [showDialogQRCode, setShowDialogQRCode] = useState(false);
  const [etiquetaTipo, setEtiquetaTipo] = useState(1);

  const tabs = {
    totalActivos: Finanzas ? 0 : null,
    activos: Finanzas ? 1 : 0,
    subActivos: Finanzas ? 2 : 1,
    activosPadre: Finanzas ? 3 : 2,
    totales: Finanzas ? 4 : 3,
  };

  const getInfo = async () => {
  try {
    setLoading(true);

    console.log("Entrando a getInfo Activos Fijos");
    console.log("activeIndex:", activeIndex);
    console.log("tabs:", tabs);
    console.log("fecha:", fecha);

    const estadosTempo = await getEstadosCategory("ActivosFijos");
    setEstados(Array.isArray(estadosTempo) ? estadosTempo : []);

    const areasUsuario = userAuth?.IdsAreas
      ? userAuth.IdsAreas.split(",").map((a) => Number(a.trim()))
      : [];

    if (activeIndex === tabs.totalActivos) {
      const activosT = await getActivosFijosTotales(fecha);
      const lista = Array.isArray(activosT) ? activosT : [];

      setActivosFijosTot(
        userAuth?.IdRol === 1
          ? lista.filter((i) => i?.ActivoPadre === false)
          : filtrarActivos(lista, areasUsuario, userAuth, false)
      );
    } else if (activeIndex === tabs.activos) {
      const activosTempo = await getActivosFijos(fecha);
      const lista = Array.isArray(activosTempo) ? activosTempo : [];

      setActivosFijos(
        userAuth?.IdRol === 1
          ? lista.filter((i) => i?.ActivoPadre === false)
          : filtrarActivos(lista, areasUsuario, userAuth, false)
      );
    } else if (activeIndex === tabs.subActivos) {
      const activos = Array.isArray(activosFijos) ? activosFijos : [];
      const subActivos = await getSubActivosFijos(fecha);
      const listaSub = Array.isArray(subActivos) ? subActivos : [];

      const idsActivos = activos.map((a) => a.IdActivo);
      const subActivosFiltrados = listaSub.filter((sa) =>
        idsActivos.includes(sa.IdActivo)
      );

      setSubActivosList(subActivosFiltrados);
    } else if (activeIndex === tabs.activosPadre) {
      const activosTempo = await getActivosFijos(fecha);
      const lista = Array.isArray(activosTempo) ? activosTempo : [];

      const activosFiltrados = lista.filter((i) => i?.ActivoPadre === true);
      setActivosFijosPadre(activosFiltrados);
    } else if (activeIndex === tabs.totales) {
      const activos = Array.isArray(activosFijos) ? activosFijos : [];
      const activosTempo = await getActivosTotales(fecha);
      const lista = Array.isArray(activosTempo) ? activosTempo : [];

      const idsActivos = activos.map((a) => a.IdActivo);
      const activosFiltrados = lista.filter((sa) =>
        idsActivos.includes(sa.IdActivo)
      );

      setActivosTotales(activosFiltrados);
    }
  } catch (error) {
    console.error("Error cargando Activos Fijos:", error);
    toastShow(toast, "error", "Error", "No se pudieron cargar los activos fijos.");
  } finally {
    setLoading(false);
  }
};

  // const getInfo2 = async () => {
  //   const areasUsuario = userAuth?.IdsAreas?.split(",").map((a) =>
  //     Number(a.trim())
  //   );
  //   const activosTempo = await getActivosFijos(fecha);
  //   setActivosFijos(
  //     filtrarActivos(activosTempo, areasUsuario, userAuth, false)
  //   );

  //   const activos = [...activosFijos];
  //   const subActivos = await getSubActivosFijos(fecha);

  //   const idsActivos = activos.map(a => a.IdActivo);

  //   const subActivosFiltrados = subActivos.filter(sa => idsActivos.includes(sa.IdActivo));

  //   setSubActivosList(subActivosFiltrados);
  // };

  const manejarEdicionActivo = (rowData) => {
    setShowDialog(true);
    setSelected(rowData);

    if (rowData?.TieneActivoPadre) {
      setActivoPadre(false);
    } else {
      setActivoPadre(!!rowData?.ActivoPadre);
    }
  };

  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdActivo: item.IdActivo,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdActivo: data.IdActivo,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length}  ${changes.length > 1 ? 'Activos' : 'Activo' } ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdActivos = changes.map((item) => item.IdActivo);
                cambiarEstado(e.value.IdStatus, IdActivos.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };
  
  const cambiarEstado = async (IdStatus, IdActivos) => {
    const result = await changeEstadoActivos({ IdStatus, IdActivos });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };

  const changeEstadoSub = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdSubActivo: item.IdSubActivo,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdSubActivo: data.IdSubActivo,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length}  ${changes.length > 1 ? 'SubActivos' : 'SubActivo' } ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdSubActivos = changes.map((item) => item.IdSubActivo);
                cambiarEstadoSub(e.value.IdStatus, IdSubActivos.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };
  
  const cambiarEstadoSub = async (IdStatus, IdSubActivos) => {
    const result = await changeEstadoSubActivos({ IdStatus, IdSubActivos });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };

  const columns = [
    {
      field: "IdActivo",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "Type",
      header: "Tipo Activo",
      headerEn: "Active Type",
      frozen: true,
      className: "Xsmall",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      frozen: true,
      filter: false,
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
      editable: Finanzas,
      cellEditor: changeEstado,
    },
    {
      field: "CodigoActivo",
      header: "Código",
      headerEn: "Code",
      className: "Xsmall",
      frozen: true,
      Format: 'Modal',
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
      sumary: 'count',
    },
    {
      field: "NombreActivo",
      header: "Nombre",
      headerEn: "Name",
      className: "XXXlarge",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "Marca",
      header: "Marca",
      headerEn: "Brand",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "Modelo",
      header: "Modelo",
      headerEn: "Model",
      className: "medium",
      hidden: activeIndex === 1,
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "Ano",
      header: "Año",
      hidden: activeIndex === 1,
      headerEn: "Year",
      className: "Xsmall",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "Serie",
      header: "Serie",
      hidden: activeIndex === 1,
      headerEn: "Serie",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "SubTipoActivo",
      header: "Sub Tipo Activo",
      headerEn: "Sub Type Asset",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "NombreCompleto",
      hidden: activeIndex === 1,
      header: "Nombre Personal",
      headerEn: "Personal Name",
      className: "Xlamediumrge",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "Comentario",
      hidden: activeIndex === 1,
      header: "Comentario",
      headerEn: "Comment",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      header: 'Fecha Adquisición',
      headerEn: 'Acquisition Date',
      hidden: activeIndex === 1,
      field: 'FechaAdquisicion',
      className: "small",
      Format: 'Date',
    },
    {
      header: 'Fecha Uso',
      headerEn: 'Use Date',
      field: 'FechaUso',
      hidden: activeIndex === 1,
      className: "small",
      Format: 'Date',
    },
    {
      header: 'Vida Util',
      headerEn: 'Useful life',
      field: 'VidaUtil',
      hidden: activeIndex === 1,
      className: "small",
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      header: 'Valor Lempiras',
      headerEn: 'Lempiras Value',
      field: 'Valor',
      className: "small",
      Format: 'Currency',
      Sumary: 'sum',
      hidden: Finanzas && activeIndex === 1,
    },
    {
      header: 'V - R',
      headerEn: 'V - R',
      field: 'ValorAR',
      hidden: Finanzas && activeIndex === 1,
      className: 'small',
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      header: 'Fecha Comenzo Depreciarse',
      headerEn: 'Date Began to Depreciate',
      field: 'FechaCominzaDepreciarse',
      hidden: Finanzas && activeIndex === 1,
      className: 'Xlarge',
      Format: 'Date',
    },
    //DepreciacionMensual
    {
      header: 'Dep. Mensual',
      headerEn: 'Monthly Depreciation',
      field: 'DepreciacionMensual',
      className: 'small',
      Format: 'Currency',
      hidden: Finanzas && activeIndex === 1,
      Sumary: 'sum',
    },
    // MesesUso
    {
      header: 'Meses Uso',
      headerEn: 'Months of Use',
      hidden: Finanzas && activeIndex === 1,
      field: 'MesesUso',
      className: 'Xsmall',
      Format: 'Center',
    },
    // DepreciacionAcumulada
    {
      header: 'Dep. Acumulada',
      headerEn: 'Accumulated Depreciation',
      field: 'DepreciacionAcumulada',
      className: 'small',
      hidden: Finanzas && activeIndex === 1,
      Format: 'Currency',
      Sumary: 'sum',
    },
    //DepreciacionEjercicio
    {
      hidden: Finanzas && activeIndex === 1,
      header: 'Dep. Ejercicio',
      headerEn: 'Depreciation Exercise',
      field: 'DepreciacionEjercicio',
      className: 'small',
      Sumary: 'sum',
      Format: 'Currency',
    },
    //SaldoPorDepreciar
    {
      header: 'Saldo Por Depreciar',
      headerEn: 'Balance to Depreciate',
      hidden: Finanzas && activeIndex === 1,
      field: 'SaldoPorDepreciar',
      className: 'small',
      Format: 'Currency',
      Sumary: 'sum',
    },
    //DepreciacionAcumuladaFinBalance
    {
      header: 'Dep. Acumulada Fin Balance',
      headerEn: 'Accumulated Depreciation End Balance',
      hidden: Finanzas && activeIndex === 1,
      field: 'DepreciacionAcumuladaFinBalance',
      className: 'large',
      Format: 'Currency',
      Sumary: 'sum',
    },
    //ValorLibros
    {
      header: 'Valor Libros',
      headerEn: 'Book Value',
      field: 'ValorLibros',
      className: 'small',
      hidden: Finanzas && activeIndex === 1,
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      header: 'Padre',
      field: 'ActivoPadre',
      frozen: true,
      alignFrozen: "right",
      className: 'Xsmall',
      Format: 'Template',
      align: "center",
      body: (rowData) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <Checkbox checked={rowData.ActivoPadre} />
        </div>
      ),
    },
    {
      header: 'Tiene Padre',
      field: 'TieneActivoPadre',
      frozen: true,
      alignFrozen: "right",
      className: 'Xsmall',
      Format: 'Template',
      align: "center",
      body: (rowData) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <Checkbox checked={rowData.TieneActivoPadre} />
        </div>
      ),
    },
    {
      field: "IdActivo",
      className: "colum-width-small",
      header: "",
      Format: "Botones",
      filter: false,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdActivo){
              manejarEdicionActivo(rowData);
            }
          },
          tooltipOptions: {position: "left"},
        },
        {
          icon: "pi pi-image",
          tooltip: "Imágenes",
          onClick: (rowData) => {
            if(rowData?.IdActivo){
              setShowDialogImagenes(true)
              setSelected([rowData])
            }
          },
          tooltipOptions: {position: "left"},
        },
      ],
    },
    activeIndex === 1 ?
    {
      field: "",
      Format: "SplitButton",
      filter: false,
      className: 'Xsmall',
      alignFrozen: "right",
      frozen: true,
      Botones: [
        {
          icon: "pi pi-print",
          tooltip: "QR",
          tooltipOptions: { position: "left"},
          onClick: (e) => {
            if(e?.IdActivo){
              if (selected.length > 0) {
                if (selected.length > 50) {
                  const first50Selected = selected.slice(0, 50);
                  setSelected(first50Selected);
                  toastShow(toast, "warn", "Advertencia", "Solo se muestran las etiquetas de 50 activos");
                  setTimeout(() => {
                    setShowDialogQRCode(true);
                    setEtiquetaTipo(2)
                  }, 700);
                } else {
                  setSelected(selected);
                  setShowDialogQRCode(true);
                  setEtiquetaTipo(2)
                }
                setSelected(selected)
              } else {
                setEtiquetaTipo(2)
                setShowDialogQRCode(true);
                setSelected([e])
              }
            }
          },
          items: [
            {
              label: "4in x 3in ",
              onClick: (e) => {
                if (selected.length > 0) {
                  if (selected.length > 50) {
                    const first50Selected = selected.slice(0, 50);
                    setSelected(first50Selected);
                    toastShow(toast, "warn", "Advertencia", "Solo se muestran las etiquetas de 50 activos");
                    setTimeout(() => {
                      setShowDialogQRCode(true);
                      setEtiquetaTipo(1)
                    }, 700);
                  }else{
                    setSelected(selected);
                    setShowDialogQRCode(true);
                    setEtiquetaTipo(1)
                  }
                  setSelected(selected)
                } else {
                  if(selected?.IdActivo){
                    setEtiquetaTipo(1)
                    setShowDialogQRCode(true);
                    setSelected([e])
                  }
                }
              },
            },
            {
              label: "6in x 4in ",
              onClick: (e) => {
                if (selected.length > 0) {
                  if (selected.length > 50) {
                    const first50Selected = selected.slice(0, 50);
                    setSelected(first50Selected);
                    toastShow(toast, "warn", "Advertencia", "Solo se muestran las etiquetas de 50 activos");
                    setTimeout(() => {
                      setShowDialogQRCode(true);
                      setEtiquetaTipo(2)
                    }, 700);
                  } else {
                    setSelected(selected);
                    setShowDialogQRCode(true);
                    setEtiquetaTipo(2)
                  }
                  setSelected(selected)
                } else {
                  if(selected?.IdActivo){
                    setEtiquetaTipo(2)
                    setShowDialogQRCode(true);
                    setSelected([e])
                  }
                }
              },
            },
            {
              label: "4in x 1in ",
              onClick: (e) => {
                if (selected.length > 0) {
                  if (selected.length > 50) {
                    const first50Selected = selected.slice(0, 50);
                    setSelected(first50Selected);
                    toastShow(toast, "warn", "Advertencia", "Solo se muestran las etiquetas de 50 activos");
                    setTimeout(() => {
                      setShowDialogQRCode(true);
                      setEtiquetaTipo(3)
                    }, 700);
                  } else {
                    setSelected(selected);
                    setShowDialogQRCode(true);
                    setEtiquetaTipo(3)
                  }
                  setSelected(selected)
                } else {
                  if(selected?.IdActivo){
                    setEtiquetaTipo(3)
                    setShowDialogQRCode(true);
                    setSelected([e])
                  }
                }
              },
            }
          ]
        }
      ]
    } : null

  ];

  const table = {
    key: 'IdActivo',
    Columns: columns,
    Data: activosFijos,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
    showModal: () => { }
  };

  const columnsSA = [
    {
      field: "IdSubActivo",
      header: "ID",
      headerEn: "ID",
      body: (rowData) => rowData.IdSubActivo,
      frozen: "frozen",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      filter: false,
      frozen: true,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
      editable: Finanzas,
      cellEditor: changeEstadoSub,
    },
    {
      field: "CodigoSubActivo",
      header: "Código",
      headerEn: "Code",
      frozen: true,
      Sumary: "count",
      className: "small",
      Format: 'Modal',
      onCellDoubleClicked: ({ data }) => {
        setShowDialog1(true);
        setSelected1(data);
      },
    },
    {
      header: "Nombre",
      headerEn: "Name",
      field: "NombreSubActivo",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog1(true);
        setSelected1(data);
      },
    },
    {
      field: "CodigoActivo",
      header: "Código Activo",
      headerEn: "Active Code",
      className: "small",
    },
    {
      field: "NombreActivo",
      header: "Nombre Activo",
      headerEn: "Name Asset",
      className: "Xlarge",
    },
    {
      header: "Comentario",
      headerEn: "Comment",
      field: "Comentario",
      className: "large",
    },
    {
      field: "Marca",
      header: "Marca",
      headerEn: "Brand",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Modelo",
      header: "Modelo",
      headerEn: "Model",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Ano",
      header: "Año",
      headerEn: "Year",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Serie",
      header: "Serie",
      headerEn: "Serie",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: 'Fecha Adquisición',
      headerEn: 'Acquisition Date',
      field: 'FechaAdquisicion',
      className: "small"
    },
    {
      header: 'Fecha Uso',
      headerEn: 'Use Date',
      field: 'FechaUso',
      className: "small"
    },
    {
      header: 'Vida Util',
      headerEn: 'Useful life',
      field: 'VidaUtil',
      className: "small",
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      header: 'Valor Lempiras',
      headerEn: 'Lempiras Value',
      field: 'Valor',
      hidden: Finanzas,
      className: "small",
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      header: 'V - R',
      headerEn: 'V - R',
      field: 'ValorAR',
      hidden: Finanzas,
      className: 'small',
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      header: 'Fecha Comenzo Depreciarse',
      headerEn: 'Date Began to Depreciate',
      hidden: Finanzas,
      field: 'FechaCominzaDepreciarse',
      className: 'Xlarge',
      Format: 'Date',
    },
    //DepreciacionMensual
    {
      header: 'Dep. Mensual',
      headerEn: 'Monthly Depreciation',
      field: 'DepreciacionMensual',
      hidden: Finanzas,
      className: 'small',
      Format: 'Currency',
      Sumary: 'sum',
    },
    // MesesUso
    {
      header: 'Meses Uso',
      headerEn: 'Months of Use',
      field: 'MesesUso',
      hidden: Finanzas,
      className: 'Xsmall',
      Format: 'Center',
    },
    // DepreciacionAcumulada
    {
      header: 'Dep. Acumulada',
      headerEn: 'Accumulated Depreciation',
      field: 'DepreciacionAcumulada',
      className: 'small',
      Format: 'Currency',
      hidden: Finanzas,
      Sumary: 'sum',
    },
    //DepreciacionEjercicio
    {
      header: 'Dep. Ejercicio',
      headerEn: 'Depreciation Exercise',
      field: 'DepreciacionEjercicio',
      hidden: Finanzas,
      className: 'small',
      Sumary: 'sum',
      Format: 'Currency',
    },
    //SaldoPorDepreciar
    {
      header: 'Saldo Por Depreciar',
      headerEn: 'Balance to Depreciate',
      field: 'SaldoPorDepreciar',
      className: 'small',
      hidden: Finanzas,
      Format: 'Currency',
      Sumary: 'sum',
    },
    //DepreciacionAcumuladaFinBalance
    {
      header: 'Dep. Acumulada Fin Balance',
      headerEn: 'Accumulated Depreciation End Balance',
      field: 'DepreciacionAcumuladaFinBalance',
      className: 'large',
      hidden: Finanzas,
      Format: 'Currency',
      Sumary: 'sum',
    },
    //ValorLibros
    {
      header: 'Valor Libros',
      headerEn: 'Book Value',
      field: 'ValorLibros',
      hidden: Finanzas,
      className: 'small',
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      field: "IdSubActivo",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdSubActivo){
              setShowDialog1(true);
              setSelected1(rowData);
            }
          },
        },
        {
          icon: "pi pi-image",
          tooltip: "Imágenes",
          onClick: (rowData) => {
            if(rowData?.IdSubActivo){
              setShowDialogImagenesSUB(true)
              setSelectedSub([rowData])
            }
          },
          tooltipOptions: {position: "left",},
        }
      ],
    },
  ];

  const tableSA = {
    Columns: columnsSA,
    Data: subActivosList,
    loading: loading,
    showModal: () => {},
    selected: selectedSub,
    setSelected: setSelectedSub,
  };

  const columnsPadre = [
    {
      field: "IdActivo",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "Type",
      header: "Tipo Activo",
      headerEn: "Active Type",
      frozen: true,
      className: "Xsmall",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      frozen: true,
      filter: false,
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
      editable: Finanzas,
      cellEditor: changeEstado,
    },
    {
      field: "CodigoActivo",
      header: "Código",
      headerEn: "Code",
      className: "Xsmall",
      frozen: true,
      Format: 'Modal',
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
      sumary: 'count',
    },
    {
      field: "NombreActivo",
      header: "Nombre",
      headerEn: "Name",
      className: "XXXlarge",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "Marca",
      header: "Marca",
      headerEn: "Brand",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "Modelo",
      header: "Modelo",
      headerEn: "Model",
      className: "medium",
      hidden: activeIndex === 1,
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "Ano",
      header: "Año",
      hidden: activeIndex === 1,
      headerEn: "Year",
      className: "Xsmall",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "Serie",
      header: "Serie",
      hidden: activeIndex === 1,
      headerEn: "Serie",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "SubTipoActivo",
      header: "Sub Tipo Activo",
      headerEn: "Sub Type Asset",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "NombreCompleto",
      hidden: activeIndex === 1,
      header: "Nombre Personal",
      headerEn: "Personal Name",
      className: "Xlamediumrge",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      field: "Comentario",
      hidden: activeIndex === 1,
      header: "Comentario",
      headerEn: "Comment",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        manejarEdicionActivo(data);
      },
    },
    {
      header: 'Fecha Adquisición',
      headerEn: 'Acquisition Date',
      hidden: activeIndex === 1,
      field: 'FechaAdquisicion',
      className: "small",
      Format: 'Date',
    },
    {
      header: 'Fecha Uso',
      headerEn: 'Use Date',
      field: 'FechaUso',
      hidden: activeIndex === 1,
      className: "small",
      Format: 'Date',
    },
    {
      header: 'Vida Util',
      headerEn: 'Useful life',
      field: 'VidaUtil',
      hidden: activeIndex === 1,
      className: "small",
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      header: 'Valor Lempiras',
      headerEn: 'Lempiras Value',
      field: 'Valor',
      className: "small",
      Format: 'Currency',
      Sumary: 'sum',
      hidden: Finanzas && activeIndex === 1,
    },
    {
      header: 'V - R',
      headerEn: 'V - R',
      field: 'ValorAR',
      hidden: Finanzas && activeIndex === 1,
      className: 'small',
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      header: 'Fecha Comenzo Depreciarse',
      headerEn: 'Date Began to Depreciate',
      field: 'FechaCominzaDepreciarse',
      hidden: Finanzas && activeIndex === 1,
      className: 'Xlarge',
      Format: 'Date',
    },
    //DepreciacionMensual
    {
      header: 'Dep. Mensual',
      headerEn: 'Monthly Depreciation',
      field: 'DepreciacionMensual',
      className: 'small',
      Format: 'Currency',
      hidden: Finanzas && activeIndex === 1,
      Sumary: 'sum',
    },
    // MesesUso
    {
      header: 'Meses Uso',
      headerEn: 'Months of Use',
      hidden: Finanzas && activeIndex === 1,
      field: 'MesesUso',
      className: 'Xsmall',
      Format: 'Center',
    },
    // DepreciacionAcumulada
    {
      header: 'Dep. Acumulada',
      headerEn: 'Accumulated Depreciation',
      field: 'DepreciacionAcumulada',
      className: 'small',
      hidden: Finanzas && activeIndex === 1,
      Format: 'Currency',
      Sumary: 'sum',
    },
    //DepreciacionEjercicio
    {
      hidden: Finanzas && activeIndex === 1,
      header: 'Dep. Ejercicio',
      headerEn: 'Depreciation Exercise',
      field: 'DepreciacionEjercicio',
      className: 'small',
      Sumary: 'sum',
      Format: 'Currency',
    },
    //SaldoPorDepreciar
    {
      header: 'Saldo Por Depreciar',
      headerEn: 'Balance to Depreciate',
      hidden: Finanzas && activeIndex === 1,
      field: 'SaldoPorDepreciar',
      className: 'small',
      Format: 'Currency',
      Sumary: 'sum',
    },
    //DepreciacionAcumuladaFinBalance
    {
      header: 'Dep. Acumulada Fin Balance',
      headerEn: 'Accumulated Depreciation End Balance',
      hidden: Finanzas && activeIndex === 1,
      field: 'DepreciacionAcumuladaFinBalance',
      className: 'large',
      Format: 'Currency',
      Sumary: 'sum',
    },
    //ValorLibros
    {
      header: 'Valor Libros',
      headerEn: 'Book Value',
      field: 'ValorLibros',
      className: 'small',
      hidden: Finanzas && activeIndex === 1,
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      header: 'Padre',
      field: 'ActivoPadre',
      frozen: true,
      alignFrozen: "right",
      className: 'Xsmall',
      Format: 'Template',
      align: "center",
      body: (rowData) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <Checkbox checked={rowData.ActivoPadre} />
        </div>
      ),
    },
    {
      header: 'Tiene Padre',
      field: 'TieneActivoPadre',
      frozen: true,
      alignFrozen: "right",
      className: 'Xsmall',
      Format: 'Template',
      align: "center",
      body: (rowData) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <Checkbox checked={rowData.TieneActivoPadre} />
        </div>
      ),
    },
    {
      field: "IdActivo",
      className: "colum-width-small",
      header: "",
      Format: "Botones",
      filter: false,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdActivo){
              manejarEdicionActivo(rowData);
            }
          },
          tooltipOptions: {position: "left"},
        },
        {
          icon: "pi pi-image",
          tooltip: "Imágenes",
          onClick: (rowData) => {
            if(rowData?.IdActivo){
              setShowDialogImagenes(true)
              setSelected([rowData])
            }
          },
          tooltipOptions: {position: "left"},
        },
      ],
    },
    activeIndex === 1 ?
    {
      field: "",
      Format: "SplitButton",
      filter: false,
      className: 'Xsmall',
      alignFrozen: "right",
      frozen: true,
      Botones: [
        {
          icon: "pi pi-print",
          tooltip: "QR",
          tooltipOptions: { position: "left"},
          onClick: (e) => {
            if(e?.IdActivo){
              if (selected.length > 0) {
                if (selected.length > 50) {
                  const first50Selected = selected.slice(0, 50);
                  setSelected(first50Selected);
                  toastShow(toast, "warn", "Advertencia", "Solo se muestran las etiquetas de 50 activos");
                  setTimeout(() => {
                    setShowDialogQRCode(true);
                    setEtiquetaTipo(2)
                  }, 700);
                } else {
                  setSelected(selected);
                  setShowDialogQRCode(true);
                  setEtiquetaTipo(2)
                }
                setSelected(selected)
              } else {
                setEtiquetaTipo(2)
                setShowDialogQRCode(true);
                setSelected([e])
              }
            }
          },
          items: [
            {
              label: "4in x 3in ",
              onClick: (e) => {
                if (selected.length > 0) {
                  if (selected.length > 50) {
                    const first50Selected = selected.slice(0, 50);
                    setSelected(first50Selected);
                    toastShow(toast, "warn", "Advertencia", "Solo se muestran las etiquetas de 50 activos");
                    setTimeout(() => {
                      setShowDialogQRCode(true);
                      setEtiquetaTipo(1)
                    }, 700);
                  }else{
                    setSelected(selected);
                    setShowDialogQRCode(true);
                    setEtiquetaTipo(1)
                  }
                  setSelected(selected)
                } else {
                  if(selected?.IdActivo){
                    setEtiquetaTipo(1)
                    setShowDialogQRCode(true);
                    setSelected([e])
                  }
                }
              },
            },
            {
              label: "6in x 4in ",
              onClick: (e) => {
                if (selected.length > 0) {
                  if (selected.length > 50) {
                    const first50Selected = selected.slice(0, 50);
                    setSelected(first50Selected);
                    toastShow(toast, "warn", "Advertencia", "Solo se muestran las etiquetas de 50 activos");
                    setTimeout(() => {
                      setShowDialogQRCode(true);
                      setEtiquetaTipo(2)
                    }, 700);
                  } else {
                    setSelected(selected);
                    setShowDialogQRCode(true);
                    setEtiquetaTipo(2)
                  }
                  setSelected(selected)
                } else {
                  if(selected?.IdActivo){
                    setEtiquetaTipo(2)
                    setShowDialogQRCode(true);
                    setSelected([e])
                  }
                }
              },
            },
            {
              label: "4in x 1in ",
              onClick: (e) => {
                if (selected.length > 0) {
                  if (selected.length > 50) {
                    const first50Selected = selected.slice(0, 50);
                    setSelected(first50Selected);
                    toastShow(toast, "warn", "Advertencia", "Solo se muestran las etiquetas de 50 activos");
                    setTimeout(() => {
                      setShowDialogQRCode(true);
                      setEtiquetaTipo(3)
                    }, 700);
                  } else {
                    setSelected(selected);
                    setShowDialogQRCode(true);
                    setEtiquetaTipo(3)
                  }
                  setSelected(selected)
                } else {
                  if(selected?.IdActivo){
                    setEtiquetaTipo(3)
                    setShowDialogQRCode(true);
                    setSelected([e])
                  }
                }
              },
            }
          ]
        }
      ]
    } : null

  ];

  const tablePadre = {
    key: 'IdActivo',
    Columns: columnsPadre,
    Data: activosFijosPadre,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
    showModal: () => { }
  };

  const columnsTot = [
    {
      field: "IdActivo",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Type",
      header: "Tipo Activo",
      headerEn: "Active Type",
      frozen: true,
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      frozen: true,
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "CodigoActivo",
      header: "Código",
      headerEn: "Code",
      className: "  Xsmall",
      frozen: true,
      Format: 'Modal',
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
      Sumary: 'count',
    },
    {
      field: "NombreActivo",
      header: "Nombre",
      headerEn: "Name",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Marca",
      header: "Marca",
      headerEn: "Brand",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Modelo",
      header: "Modelo",
      headerEn: "Model",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Ano",
      header: "Año",
      headerEn: "Year",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Serie",
      header: "Serie",
      headerEn: "Serie",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "NombreCompleto",
      header: "Nombre Personal",
      headerEn: "Personal Name",
      className: "Xlamediumrge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Comentario",
      header: "Comentario",
      headerEn: "Comment",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: 'Fecha Adquisición',
      headerEn: 'Acquisition Date',
      field: 'FechaAdquisicion',
      className: "small",
      Format: 'Date',
    },
    {
      header: 'Fecha Uso',
      headerEn: 'Use Date',
      field: 'FechaUso',
      className: "small",
      Format: 'Date',
    },
    {
      header: 'Vida Util',
      headerEn: 'Useful life',
      field: 'VidaUtil',
      className: "small",
      Format: 'Currency',
    },
    {
      header: 'Valor Lempiras',
      headerEn: 'Lempiras Value',
      field: 'Valor',
      className: "small",
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      header: 'V - R',
      headerEn: 'V - R',
      field: 'ValorAR',
      className: 'small',
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      header: 'Fecha Comenzo Depreciarse',
      headerEn: 'Date Began to Depreciate',
      field: 'FechaCominzaDepreciarse',
      className: 'Xlarge',
      Format: 'Date',
    },
    //DepreciacionMensual
    {
      header: 'Dep. Mensual',
      headerEn: 'Monthly Depreciation',
      field: 'DepreciacionMensual',
      className: 'small',
      Format: 'Currency',
      Sumary: 'sum',
    },
    // MesesUso
    {
      header: 'Meses Uso',
      headerEn: 'Months of Use',
      field: 'MesesUso',
      className: 'Xsmall',
      Format: 'Center',
    },
    // DepreciacionAcumulada
    {
      header: 'Dep. Acumulada',
      headerEn: 'Accumulated Depreciation',
      field: 'DepreciacionAcumulada',
      className: 'small',
      Format: 'Currency',
      Sumary: 'sum',
    },
    //DepreciacionEjercicio
    {
      header: 'Dep. Ejercicio',
      headerEn: 'Depreciation Exercise',
      field: 'DepreciacionEjercicio',
      className: 'small',
      Sumary: 'sum',
      Format: 'Currency',
    },
    //SaldoPorDepreciar
    {
      header: 'Saldo Por Depreciar',
      headerEn: 'Balance to Depreciate',
      field: 'SaldoPorDepreciar',
      className: 'small',
      Format: 'Currency',
      Sumary: 'sum',
    },
    //DepreciacionAcumuladaFinBalance
    {
      header: 'Dep. Acumulada Fin Balance',
      headerEn: 'Accumulated Depreciation End Balance',
      field: 'DepreciacionAcumuladaFinBalance',
      className: 'large',
      Format: 'Currency',
      Sumary: 'sum',
    },
    //ValorLibros
    {
      header: 'Valor Libros',
      headerEn: 'Book Value',
      field: 'ValorLibros',
      className: 'small',
      Format: 'Currency',
      Sumary: 'sum',
    },
    {
      field: "IdActivo",
      className: "colum-width-small",
      header: "",
      Format: "Botones",
      filter: false,
      alignFrozen: "right",
      Botones: [
        {
          icon: 'pi pi-angle-down',
          tooltip: 'Detalles',
          tooltipOptions: {
            position: "top",
          },
          onClick: (rowData) => {
            if(rowData?.IdActivo){
              setShowDialogTotales(true);
              setSelected(rowData);
            }
          },
        },
      ],
    },
  ];

  const tableTot = {
    Columns: columnsTot,
    Data: activosFijosTot,
    loading: loading,
    showModal: () => {}
  };

  const columsTotales = [
    {
      header: "IdActivo",
      headerEn: "",
      field: "IdActivo",
      className: "Xsmall",
      hide: userAuth.IdRol !== 1,
      frozen: true,
    },
    {
      header: "IdSubActivo",
      headerEn: "",
      field: "IdSubActivo",
      className: "Xsmall",
      hide: userAuth.IdRol !== 1,
      frozen: true,
    },
    {
      header: "Tipo",
      headerEn: "Type",
      field: "Tipo",
      className: "Xsmall",
    },
    {
      header: "Código",
      headerEn: "Code",
      field: "Codigo",
      Format: "Modal",
      className: "Xsmall",
      frozen: true,
    },
    {
      header: "Nombre",
      headerEn: "Name",
      field: "Nombre",
      className: "XXlarge",
      frozen: true,
      Sumary: "count",
    },
    {
      header: "Marca",
      headerEn: "Brand",
      field: "Marca",
    },
    {
      header: "Modelo",
      headerEn: "Model",
      field: "Modelo",
    },
    {
      header: "Serie",
      headerEn: "Serial",
      field: "Serie",
    },
    {
      header: "Area",
      headerEn: "Area",
      field: "Area",
    },
    {
      header: "Comentario",
      headerEn: "Comment",
      field: "Comentario",
      className: "Xlarge",
    },
    {
      header: "Adquisicion",
      headerEn: "Acquisition",
      field: "FechaAdquisicion",
      Format: "Date",
    },
    {
      header: "Uso",
      headerEn: "Use",
      field: "FechaUso",
      Format: "Date",
    },
    {
      header: "Vida Util",
      headerEn: "Useful Life",
      field: "VidaUtil",
      className: "Xsmall",
      Format: "Center",
    },
    {
      header: "Valor",
      headerEn: "Value",
      field: "Valor",
      Format: "Currency",      
      hidden: Finanzas,
      Sumary: "sum",
      className: "small",
    },
    {
      header: "V - R",
      headerEn: "V - R",
      hidden: Finanzas,
      field: "ValorAR",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
    },
    {
      header: "Fecha Comenzo Depreciarse",
      headerEn: "Date Began to Depreciate",
      field: "FechaCominzaDepreciarse",
      hidden: Finanzas,
      className: "Xlarge",
      Format: "Date",
    },
    //DepreciacionMensual
    {
      header: "Dep. Mensual",
      headerEn: "Monthly Depreciation",
      field: "DepreciacionMensual",
      className: "small",
      hidden: Finanzas,
      Format: "Currency",
      Sumary: "sum",
    },
    // MesesUso
    {
      hidden: Finanzas,
      header: "Meses Uso",
      headerEn: "Months of Use",
      field: "MesesUso",
      className: "Xsmall",
      Format: "Center",
    },
    // DepreciacionAcumulada
    {
      header: "Dep. Acumulada",
      hidden: Finanzas,
      headerEn: "Accumulated Depreciation",
      field: "DepreciacionAcumulada",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
    },
    //DepreciacionEjercicio
    {
      header: "Dep. Ejercicio",
      hidden: Finanzas,
      headerEn: "Depreciation Exercise",
      field: "DepreciacionEjercicio",
      className: "small",
      Sumary: "sum",
      Format: "Currency",
    },
    //SaldoPorDepreciar
    {
      header: "Saldo Por Depreciar",
      headerEn: "Balance to Depreciate",
      hidden: Finanzas,
      field: "SaldoPorDepreciar",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
    },
    //DepreciacionAcumuladaFinBalance
    {
      header: "Dep. Acumulada Fin Balance",
      headerEn: "Accumulated Depreciation End Balance",
      hidden: Finanzas,
      field: "DepreciacionAcumuladaFinBalance",
      className: "large",
      Format: "Currency",
      Sumary: "sum",
    },
    //ValorLibros
    {
      header: "Valor Libros",
      hidden: Finanzas,
      headerEn: "Book Value",
      field: "ValorLibros",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      filter: false,
      frozen: true,
      alignFrozen: "right",
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
  ];

  const tableTotales = {
    Columns: columsTotales,
    Data: activosTotales,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
    showModal: (e) => (e),
  }

  // useEffect(() => {
  //   getInfo2();
  // }, []);

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "activoFijo", config.language));
    getInfo();
    setSelected([])
  }, [fecha, activeIndex]);

  // useEffect(() => {
  //   setActiveIndex(Finanzas ? 0 : 1)
  // }, [Finanzas]);

  useEffect(() => {
    setActiveIndex(0);
  }, [Finanzas]);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "activoFijo", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            {(activeIndex === 0 || activeIndex === 1) && (
              <div className="d-flex gap-3">
                <Button
                  icon="pi pi-plus"
                  onClick={() => {
                    setShowDialog(true);
                    setSelected([]);
                    setActivoPadre(false)
                  }}
                />
              </div>
            )}

            {activeIndex === 2 && (
              <Button
                icon="pi pi-plus"
                onClick={() => {
                  setShowDialog1(true);
                  setSelected([]);
                }}
              />
            )}

            {activeIndex === 3 && (
              <Button
                icon="pi pi-plus"
                onClick={() => {
                  setShowDialog(true);
                  setSelected([]);
                  setActivoPadre(true)
                }}
                tooltip="Activo Fijo Padre"
              />
            )}

            <Button icon='pi pi-percentage' className="mx-1" onClick={e => setShowDialogDistri(true)} tooltip='Distribución de depreciación' />
            {/* <Button onClick={() => setShowDialogPartida(true)} icon='ri ri-survey-line' tooltip='Resumen depreciación' /> */}
            <div style={{ marginLeft: '10px' }}>
              <CalendarWeek
                date={fecha}
                setDate={setFecha}
                view="month"
                dateFormat="mm/yy"
                IdTipo={1}
              />
            </div>
          </div>
        }
        contenido={
          <TabView style={{ marginTop: '30px' }} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} >

            {Finanzas && (
              <TabPanel header="Total Activos">
                <div style={{ height: "84vh" }}>
                  <AgGrid table={tableTot} />
                </div>
              </TabPanel>
            )}


            <TabPanel header={"Activos"}>
              <div style={{ height: "84vh" }}>
                <AgGrid table={table} />
              </div>
            </TabPanel>

            <TabPanel header="SubActivos">
              <div style={{ height: "84vh" }}>
                <AgGrid table={tableSA} />
              </div>
            </TabPanel>

            <TabPanel header={"Activos Padre"}>
              <div style={{ height: "84vh" }}>
                <AgGrid table={tablePadre} />
              </div>
            </TabPanel>

            <TabPanel header={"Totales"}>
              <div style={{ height: "84vh" }}>
                <AgGrid table={tableTotales} />
              </div>
            </TabPanel>

          </TabView>
        }
      />

      {showDialog && (
        <ActivosFijosCRUD
          showDialog={showDialog}
          selected={selected}
          setSelected={setSelected}
          setShowDialog={setShowDialog}
          getInfo={getInfo}
          modo={selected ? "Editar" : "Crear"}
          //SUB-ACT
          showDialog1={showDialog1}
          selected1={selected1}
          setSelected1={setSelected1}
          setShowDialog1={setShowDialog1}
          ActivoPadre={activoPadre}
          setActivoPadre={setActivoPadre}
        />
      )}

      {showDialog1 && (
        <SubActivosCRUD
          toastRef={toast}
          showDialog={showDialog1}
          selected={selected1}
          setSelected={setSelected1}
          setShowDialog={setShowDialog1}
          getInfo={getInfo}
          modo={selected1 ? "Editar" : "Crear"}
        />
      )}

      {showDialogTotales && (
        <ActivosConSubAct
          showDialog={showDialogTotales}
          setShowDialog={setShowDialogTotales}
          selected={selected}
          fecha={fecha}
        />
      )}

      {/*
      <DistribucionesDepreciacionActivosDialog
        show={showDialogDistri}
        setShow={setShowDialogDistri}
        tipo={1}
      />
      */}

      {showDialogImagenes && (
        <ImagenActivos
          showDialogImagenes={showDialogImagenes}
          setShowDialogImagenes={setShowDialogImagenes}
          getInfo={getInfo}
          selected={selected}
          setSelected={setSelected}
        />
      )}

      {showDialogImagenesSUB && (
        <ImagenSubActivos
          showDialogImagenes={showDialogImagenesSUB}
          setShowDialogImagenes={setShowDialogImagenesSUB}
          getInfo={getInfo}
          selected={selectedSub}
          setSelected={setSelectedSub}
        />
      )}

      {showDialogQRCode && (
        <QRCodeModal
          showDialogQRCode={showDialogQRCode}
          selected={selected}
          setShowDialogQRCode={setShowDialogQRCode}
          getInfo={getInfo}
          setSelected={setSelected}
          setSelectedQR={setSelected}
          toastDialog={toast}
          etiquetaTipo={etiquetaTipo}
        />
      )}
    </div>
  );
};

export default ActivosFijosScreen;
